import React, {GoogleAuthProvider, signInWithPopup} from 'firebase/auth';
import {auth} from '../../firebase';
import {getDebug} from '../../library/GeneralUse';

const style = {
	// Same as NavbarButton
	googleSigninButton: `flex justify-center items-center   transition ease-in-out delay-75 duration-150 hover:delay-0 hover:duration-0   w-full h-10   font-whirlwindSecondary text-2xl text-center text-whirlwindLightest hover:text-whirlwindLight   bg-whirlwindPrimary hover:bg-whirlwindPrimaryDark   border-l-2 border-whirlwindPrimaryDarkest`,
};

const DEBUG = getDebug('auth');

export const GoogleSigninButton = () => {
	// Component methods
	const handleGoogleSignin = async () => {
		DEBUG && console.log(`handleGoogleSignin()`);

		try {
			DEBUG && console.log(`signInWithPopup(auth, provider)`);
			const provider = new GoogleAuthProvider();
			await signInWithPopup(auth, provider);
		} catch (error) {
			DEBUG && console.error(error);
		}
	};

	return (
		<button
			className={style.googleSigninButton}
			data-test-id={`signinButton_TEST`}
			onClick={async () => {
				handleGoogleSignin();
			}}
			type="button">
			Sign in
		</button>
	);
};
